export { default, type FilterOption } from "./FilterAccordion.component";
